import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { IconPack, IconsConfig } from '@app/common-modules/common-icon/common-icon.model';
import { ICONS_CONFIG } from '@app/common-modules/common-icon/common-icon.token';

export function provideIcons<const Packs extends readonly IconPack<string>[]>(config: IconsConfig<Packs>): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ICONS_CONFIG, useValue: config }]);
}
